<template src="./index.html"></template>
<script>
import data from "./data.js";
import config from "../../../../../configHttp.js";
import { uploadhistorypage, uploadhistorydelete } from "@/api/home.js";
import { delBatchData } from '@/api/workManuscript';
export default {
  name: "",
  components: {},
  data: function () {
    return {
      searchdata: data.searchdata,
      searchlist: data.searchlist,
      searchdiag: false,
      outlist: [],
      headData: data.headData,
      shaidiag: false,
      tableData: [],
      pagination: data.pagination,
      tablekey:0,
    };
  },
  created() {
    this.uploadhistorypage();
  },
  mounted() {},
  methods: {
      delBatchData(){
          let chooseitem = this.$refs.tablebox.getSelectionval();
          if (this.$emptyandnull(chooseitem)) {
              this.$message.error("请选择数据");
              return false;
          }
          let batchNos = chooseitem.map((item) => item.batchNo).join(",");
          this.$showConfirm({
              message: "确认删除?",
          }).then((res) => {
              delBatchData({batchNos:batchNos, type:"openinvoice"})
          })
      },
    fordelete() {
      var chooseitem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseitem)) {
        this.$message.error("请选择数据");
        return false;
      }
      let params = {
        ids: chooseitem.map((item) => item.id).join(","),
      };
      this.$showConfirm({
        message: "确认删除?",
      }).then((res) => {
        if (res == "confirm") {
          uploadhistorydelete(params).then((res) => {
            if (res.data.code == 1) {
              this.$message.success("删除成功");
              this.pagination.pageNum = 1;
              this.pagination.paginationkey++;
              this.uploadhistorypage();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    fordowload(row) {
      let params = {
        downUrl: config.baseURL + "upload-history/downloadErrorFile",
        typeObj: {
          toForm: true,
          fileType: row.fileName.split(".")[row.fileName.split(".").length-1],
          failUrl:this.$winURl
        },
        params: {
          batchNo: row.batchNo,
        },
      };
      this.$downloadcommon(params);
    },
    forupload(row) {
      let params = {
        downUrl: config.baseURL + "upload-history/downloadOriginalFile",
        typeObj: {
          toForm: true,
          fileType: row.fileName.split(".")[row.fileName.split(".").length-1],
          failUrl:this.$winURl
        },
        params: {
          id: row.id,
        },
      };
      this.$downloadcommon(params);
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.uploadhistorypage();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.uploadhistorypage();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.uploadhistorypage();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.uploadhistorypage();
    },
    uploadhistorypage() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.type = "OPEN_INVOICE_ACCOUNT";
      params.sort = "create_time";
      params.order = "desc";
      uploadhistorypage(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },
    //导出列表
    exportExcel() {
      let params = {
        downUrl: config.baseURL + "/upload-history/exportExcel",
        typeObj: {
          toForm: true,
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: JSON.parse(JSON.stringify(this.searchdata)),
      };
      this.$downloadcommon(params);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
